import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { LotContext } from '../../context/LotContext/lot.context'
import { LotDurationType } from '../../types/lot.interface'
import useParseOpeningHours from '../../utils/getOpeningHours.utils'
import ButtonCardsSection from './components/ButtonCardsSection/ButtonCardsSection.component'
import { lotRoute } from './route'
import { BookTicketTitle } from './Overview.style'

const Overview = () => {
    const { t } = useTranslation()
    const history = useHistory()
    const { lot } = useContext(LotContext)
    const { getDateOpeningHour } = useParseOpeningHours()

    const [hourlyDisabled, setHourlyDisabled] = useState(false)

    const onOptionClick = (durationType: LotDurationType) => {
        if (lot) {
            history.push(`${lotRoute(lot.id)}?feature=${durationType}`)
        }
    }

    useEffect(() => {
        const maxNumberOfHour = getDateOpeningHour(new Date(), lot?.openingHours || [])

        setHourlyDisabled(maxNumberOfHour === 0 || Boolean(lot && new Date(lot?.earliest_booking_date) > new Date()))
    }, [lot, getDateOpeningHour])

    return (
        <>
            <BookTicketTitle> {t('lot.bookTicket')}</BookTicketTitle>
            <ButtonCardsSection
                hourlyDisabled={hourlyDisabled}
                activeFeatures={lot?.active_features}
                onCardClick={onOptionClick}
            />
        </>
    )
}

export default Overview
